import MeasurableAdditionalInfo from './MeasurableAdditionalInfo';

export default MeasurableAdditionalInfo;
